import { render, staticRenderFns } from "./Form14ProcessHeader.vue?vue&type=template&id=84a422d6&scoped=true"
import script from "./Form14ProcessHeader.vue?vue&type=script&lang=ts"
export * from "./Form14ProcessHeader.vue?vue&type=script&lang=ts"
import style0 from "./Form14ProcessHeader.vue?vue&type=style&index=0&id=84a422d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a422d6",
  null
  
)

export default component.exports